export const chartDefaultConfigs = {
  credits: { enabled: false },
  legend: { enabled: false },
};

export const chartCumulativeSeriesName = "Cumulative";
